import React, { useEffect, useRef } from 'react';
import { Chart } from 'chart.js';
import style from './styles.module.scss';
import { useMediaQuery } from 'react-responsive';


interface I_BarChart {
    labelsList: string[][];
    dataList: number[];
    yAxisHeight: number;
    loadingBarHeight: number;
    handleOnClick: (event: MouseEvent, array: any) => void;
    priceMap: Map<string, number>;
    isLoadingBar: boolean;
}

export const BarChart = ({ labelsList, dataList, yAxisHeight, loadingBarHeight, handleOnClick, priceMap, isLoadingBar }: I_BarChart) => {
    const chartRef = useRef<HTMLCanvasElement | null>(null);
    const chartContainerRef = useRef<HTMLDivElement>(null);
    const chartInstanceRef = useRef<Chart | null>(null);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const isFirstRender = useRef(true);


    // useEffect(() => {

    // }, [dataList]);


    //將數字顯示在頂部
    const drawPlugin = {
        afterDatasetsDraw: (chart: Chart) => {
            const ctx = chart.ctx;
            if (!ctx) return;

            chart.data.datasets?.forEach((dataset, datasetIndex) => {
                const meta = chart.getDatasetMeta(datasetIndex);

                meta.data.forEach((bar, index) => {
                    const value = dataset.data?.[index] as number | undefined;
                    if (value === null || value === undefined) return;
                    ctx.fillStyle = index === 6 ? 'rgba(245, 56, 68, 1)' : 'black';
                    ctx.textAlign = "center";
                    ctx.font = "lighter 12px Arial";

                    // 防止 _model 不存在
                    const x = bar?._model?.x;
                    const y = bar?._model?.y;
                    if (x === undefined || y === undefined) return;
                    if (isLoadingBar) {
                        ctx.fillText('-', x, y - 10);
                    } else if (priceMap.has(labelsList[index][0])) {
                        ctx.fillText('$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), x, y - 10);
                    } else {
                        ctx.fillText('查價', x, y - 10);
                    }
                });
            });
        },
    };


    useEffect(() => {
        const ctx = chartRef.current;
        if (!ctx) {
            return;
        }

        // 銷毀圖表
        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
            chartInstanceRef.current = null;
        }

        const barThickness = isMobile ? 65 : 50;

        chartInstanceRef.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labelsList,
                datasets: [
                    {
                        label: 'Bar chart',
                        data: dataList,
                        backgroundColor: dataList.map((_, index) => (isLoadingBar ? 'rgba(217, 217, 217, 1)' : index === 6 ? 'rgba(240, 55, 66, 1)' : 'rgba(217, 217, 217, 1)')),
                        borderWidth: 0,
                        barThickness: barThickness,
                        hoverBackgroundColor: 'rgba(240, 55, 66, 1)',

                    },
                ],
            },
            plugins: [drawPlugin],
            options: {
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio: 2.8,
                onClick: handleOnClick,
                tooltips: {
                    enabled: false,
                },
                hover: {
                    onHover: (event: MouseEvent, chartElement: any[]) => {
                        const target = event.target as HTMLCanvasElement;
                        if (chartElement.length > 0) {
                            target.style.cursor = "pointer"; // 滑鼠停在 bar 上時變成 pointer
                        } else {
                            target.style.cursor = "default"; // 離開 bar 後恢復 default
                        }
                    },
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                display: false,
                                max: yAxisHeight,
                                min: 0,
                            },
                            gridLines: {
                                display: false,
                            },
                        },
                    ],
                    xAxes: [
                        {
                            ticks: {
                                autoSkip: false,
                                fontSize: 14,
                            },
                            gridLines: {
                                display: false,
                            },
                        },
                    ],
                },
                legend: {
                    display: false,
                }
            },
        });
        isFirstRender.current = false;

        if (isMobile) {
            scrollToCenter();
        }

        // return () => {
        //     // 銷毀圖表
        //     if (chartInstanceRef.current) {
        //         chartInstanceRef.current.destroy();
        //         chartInstanceRef.current = null;
        //     }
        // };
    }, [labelsList]);


    const scrollToCenter = () => {
        const x6 = chartInstanceRef.current!.getDatasetMeta(0).data[6]._model.x;
        const x2 = chartInstanceRef.current!.getDatasetMeta(0).data[2]._model.x;
        console.log(chartInstanceRef.current!.getDatasetMeta(0).data[2]._model);
        const scrollContainer = chartContainerRef.current;
        if (scrollContainer) {
            scrollContainer.scrollLeft = x6 - x2;
        }
    };

    return (
        <div className={style.chartWrapper} ref={chartContainerRef}>
            <div className={style.chartAreaWrapper}>
                <canvas ref={chartRef} />
            </div>
        </div>

    );
};


